import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";

const PhysiotherapyTab = ({
  emrRecordId,
  emrRecord,
  emrRecordLocal,
  setEmrRecordLocal,
}) => {
  const [formData, setFormData] = useState({
    joint: null,
    muscles: null,
    treatment: null,
    position: null,
    therapy: null,
    total_hjhs_scoring: null,
    total_fish_scoring: null,
    comments: null,
  });

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/physiotherapy/record/${emrRecordId}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        // console.log("this is response", JSON.stringify(response.data));
        if (response.data.physiotherapy) {
          setFormData({
            ...formData,
            ...response.data.physiotherapy.physiotherapy_score,
          });
        }
      })
      .catch(function (error) {
        if (error.response?.data?.message) {
          toast.error(JSON.stringify(error.response.data.message));
        }
        console.log(JSON.stringify(error.response?.data));
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    //alert([input.name]);
    setFormData({
      ...formData,
      [input.name]: input.checked,
    });
  };
  const handleChangeValue = ({ currentTarget: input }) => {
    let value = input.value;
    // Convert to number for numeric fields
    if (
      input.name === "total_hjhs_scoring" ||
      input.name === "total_fish_scoring"
    ) {
      value = value === "" ? null : Number(value);
    }
    setFormData({
      ...formData,
      [input.name]: value,
    });
  };

  const dropDownChange = (selected, dropdown) => {
    //console.log("this is selected", JSON.stringify(dropdown.name));
    setFormData({
      ...formData,
      [dropdown.name]: selected ? selected.value : null,
    });
  };

  const updatePhysiotherapy = (e) => {
    e.preventDefault();

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/physiotherapy/update/${emrRecordId}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData, physiotherapy: true },
    };
    axios(config)
      .then(function (response) {
        localStorage.setItem(
          `${emrRecordId}-physiotherapy`,
          JSON.stringify(formData)
        );
        toast.success("Physiotherapy saved Successfully.");
      })
      .catch(function (error) {
        if (error.response?.data?.message) {
          toast.error(JSON.stringify(error.response.data.message));
        }
        console.log(JSON.stringify(error.response?.data));
      });
  };

  // Dropdown options - customize these based on your requirements
  const jointOptions = [
    { value: "right_shoulder", label: "RIGHT SHOULDER" },
    { value: "right_elbow", label: "RIGHT ELBOW" },
    { value: "right_wrist", label: "RIGHT WRIST" },
    { value: "right_four_arm", label: "RIGHT FOUR ARM" },
    { value: "right_hip", label: "RIGHT HIP" },
    { value: "right_knee", label: "RIGHT KNEE" },
    { value: "right_ankle", label: "RIGHT ANKLE" },
    { value: "left_shoulder", label: "LEFT SHOULDER" },
    { value: "left_elbow", label: "LEFT ELBOW" },
    { value: "left_wrist", label: "LEFT WRIST" },
    { value: "left_four_arm", label: "LEFT FOUR ARM" },
    { value: "left_hip", label: "LEFT HIP" },
    { value: "left_knee", label: "LEFT KNEE" },
    { value: "left_ankle", label: "LEFT ANKLE" },
  ];

  const musclesOptions = [
    { value: "deltoids_muscles", label: "DELTOIDS MUSCLES" },
    { value: "trapezius_muscles", label: "TRAPEZIUS MUSCLES" },
    { value: "rhomboid_minor_muscles", label: "RHOMBOID MINOR MUSCLES" },
    { value: "rhomboid_major_muscles", label: "RHOMBOID MAJOR MUSCLES" },
    { value: "supraspinatus_muscles", label: "SUPRASPINATUS MUSCLES" },
    { value: "infraspinatus_muscles", label: "INFRASPINATUS MUSCLES" },
    { value: "subscapularis_muscles", label: "SUBSCAPULARIS MUSCLES" },
    { value: "biceps_brachii", label: "BICEPS BRACHII" },
    { value: "brachialis", label: "BRACHIALIS" },
    { value: "brachioradialis", label: "BRACHIORADIALIS" },
    { value: "triceps_brachii", label: "TRICEPS BRACHII" },
    { value: "anconeus_extensors", label: "ANCONEUS(EXTENSORS)" },
    { value: "pronators", label: "PRONATORS" },
    { value: "supinators", label: "SUPINATORS" },
    { value: "hip_flexors", label: "HIP FLEXORS" },
    { value: "hip_extensors", label: "HIP EXTENSORS" },
    { value: "hip_abductors", label: "HIP ABDUCTORS" },
    { value: "hip_adductors", label: "HIP ADDUCTORS" },
    { value: "hip_rotators", label: "HIP ROTATORS" },
    { value: "hamstrings", label: "HAMSTRINGS" },
    { value: "quadriceps", label: "QUADRICEPS" },
    { value: "calf_muscles", label: "CALF MUSCLES" },
  ];

  const treatmentOptions = [
    {
      value: "upperlimb_basic_activity_mv_shoulder",
      label: "UPPERLIMB BASIC ACTIVILY M.V SHOULDER",
    },
    {
      value: "upperlimb_basic_activity_mv_elbow",
      label: "UPPERLIMB BASIC ACTIVILY M.V ELBOW",
    },
    {
      value: "upperlimb_basic_activity_mv_four_arm",
      label: "UPPERLIMB BASIC ACTIVILY M.V FOUR ARM",
    },
    {
      value: "upperlimb_basic_activity_mv_wrist",
      label: "UPPERLIMB BASIC ACTIVILY M.V WRIST",
    },
    {
      value: "lowerlimb_basic_activity_mv_hip",
      label: "LOWERLIMB BASIC ACTIVILY M.V HIP",
    },
    {
      value: "lowerlimb_basic_activity_mv_knee",
      label: "LOWERLIMB BASIC ACTIVILY M.V KNEE",
    },
    {
      value: "lowerlimb_basic_activity_mv_ankle",
      label: "LOWERLIMB BASIC ACTIVILY M.V ANKLE",
    },
    {
      value: "strengthening_exercises_ul_shoulder",
      label: "STRENGTHENING EXCERCISES FOR U.L OF SHOULDER",
    },
    {
      value: "strengthening_exercises_ul_elbow",
      label: "STRENGTHENING EXCERCISES FOR U.L OF ELBOW",
    },
    {
      value: "strengthening_exercises_ul_four_arm",
      label: "STRENGTHENING EXCERCISES FOR U.L OF FOUR ARM",
    },
    {
      value: "strengthening_exercises_ul_wrist",
      label: "STRENGTHENING EXCERCISES FOR U.L OF WRIST",
    },
    {
      value: "strengthening_exercises_ll_hip",
      label: "STRENGTHENING EXCERCISES FOR L.L OF HIP",
    },
    {
      value: "strengthening_exercises_ll_knee",
      label: "STRENGTHENING EXCERCISES FOR L.L OF KNEE",
    },
    {
      value: "strengthening_exercises_ll_ankle",
      label: "STRENGTHENING EXCERCISES FOR L.L OF ANKLE",
    },
    {
      value: "upper_body_stretches_exercise",
      label: "UPPER BODY STRETCHES EXERCISE",
    },
    {
      value: "lower_body_stretches_exercise",
      label: "LOWER BODY STRETCHES EXERCISE",
    },
    {
      value: "neck_body_stretches_exercise",
      label: "NECK BODY STRETCHES EXERCISE",
    },
  ];

  const positionOptions = [
    { value: "sitting", label: "SITTING" },
    { value: "supine", label: "SUPINE" },
    { value: "proneline", label: "PRONELINE" },
    { value: "standing", label: "STANDING" },
  ];

  const therapyOptions = [
    { value: "physiotherapy", label: "PHYSIOTHERAPY" },
    { value: "price", label: "PRICE" },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <form onSubmit={(e) => updatePhysiotherapy(e)}>
        {/* Save Button */}
        <div className="d-flex justify-content-end mb-4">
          <Button variant="primary" size="large" type="submit">
            Save
          </Button>
        </div>

        {/* Row 1: Joint, Muscles, Position */}
        <Row className="mb-4">
          <Col xs={12} md={4} className="mb-3 mb-md-0">
            <div className="newPatientItem w-100">
              <label
                htmlFor="joint"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Joint
              </label>
              <Select
                name="joint"
                onChange={(selected) => {
                  dropDownChange(selected, { name: "joint" });
                }}
                value={
                  formData.joint
                    ? jointOptions.find(
                        (option) => option.value === formData.joint
                      )
                    : null
                }
                className="newPatientSelect"
                options={jointOptions}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                isClearable
              />
            </div>
          </Col>
          <Col xs={12} md={4} className="mb-3 mb-md-0">
            <div className="newPatientItem w-100">
              <label
                htmlFor="muscles"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Muscles
              </label>
              <Select
                name="muscles"
                onChange={(selected) => {
                  dropDownChange(selected, { name: "muscles" });
                }}
                value={
                  formData.muscles
                    ? musclesOptions.find(
                        (option) => option.value === formData.muscles
                      )
                    : null
                }
                className="newPatientSelect"
                options={musclesOptions}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                isClearable
              />
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="newPatientItem w-100">
              <label
                htmlFor="position"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Position
              </label>
              <Select
                name="position"
                onChange={(selected) => {
                  dropDownChange(selected, { name: "position" });
                }}
                value={
                  formData.position
                    ? positionOptions.find(
                        (option) => option.value === formData.position
                      )
                    : null
                }
                className="newPatientSelect"
                options={positionOptions}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                isClearable
              />
            </div>
          </Col>
        </Row>

        {/* Row 2: Treatment, Therapy, HJHS Scoring, FISH Scoring */}
        <Row className="mb-4">
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div className="newPatientItem w-100">
              <label
                htmlFor="treatment"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Treatment
              </label>
              <Select
                name="treatment"
                onChange={(selected) => {
                  dropDownChange(selected, { name: "treatment" });
                }}
                value={
                  formData.treatment
                    ? treatmentOptions.find(
                        (option) => option.value === formData.treatment
                      )
                    : null
                }
                className="newPatientSelect"
                options={treatmentOptions}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                isClearable
              />
            </div>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div className="newPatientItem w-100">
              <label
                htmlFor="therapy"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Therapy
              </label>
              <Select
                name="therapy"
                onChange={(selected) => {
                  dropDownChange(selected, { name: "therapy" });
                }}
                value={
                  formData.therapy
                    ? therapyOptions.find(
                        (option) => option.value === formData.therapy
                      )
                    : null
                }
                className="newPatientSelect"
                options={therapyOptions}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                isClearable
              />
            </div>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div className="newPatientItem w-100">
              <label
                htmlFor="total_hjhs_scoring"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Total HJHS Scoring
              </label>
              <input
                type="number"
                className="form-control"
                name="total_hjhs_scoring"
                placeholder="Enter total HJHS scoring"
                onChange={handleChangeValue}
                value={formData.total_hjhs_scoring || ""}
                min="0"
                style={{ height: "38px" }}
              />
            </div>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <div className="newPatientItem w-100">
              <label
                htmlFor="total_fish_scoring"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Total FISH Scoring
              </label>
              <input
                type="number"
                className="form-control"
                name="total_fish_scoring"
                placeholder="Enter total FISH scoring"
                onChange={handleChangeValue}
                value={formData.total_fish_scoring || ""}
                min="0"
                style={{ height: "38px" }}
              />
            </div>
          </Col>
        </Row>

        {/* Row 3: Comments */}
        <Row>
          <Col xs={12}>
            <div className="newPatientItem w-100">
              <label
                htmlFor="comments"
                style={{ marginBottom: "8px", fontWeight: "500" }}
              >
                Comments
              </label>
              <textarea
                className="form-control"
                name="comments"
                placeholder="Enter comments..."
                rows={4}
                onChange={handleChangeValue}
                value={formData.comments || ""}
                style={{ resize: "vertical" }}
              />
            </div>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default PhysiotherapyTab;
